import { uploadToAliyunOSS } from './aliyun-oss';
/**
 * 统一文件上传入口
 *
 * @example
 * import { upload } from '@arcubase/client-ts'
 *
 * const token = await userApi.getUploadToken()
 * const result = await upload(token, file, {
 *   onProgress: (percent) => console.log(`${percent * 100}%`),
 *   onSuccess: () => console.log('上传成功'),
 *   onError: (err) => console.error('上传失败', err)
 * })
 */
export async function upload(token, file, options = {}) {
    switch (token.mode) {
        case 'aliyun-oss':
            return uploadToAliyunOSS(token, file, options);
        default:
            throw new Error(`Unsupported upload mode: ${token.mode}`);
    }
}
